import React from "react";
import { Link } from "react-router-dom";
import { Fingerprint, MapPin, Phone, Mail, Clock } from "lucide-react";
import { COMPANY, SERVICES } from "../../data/content";

export const Footer = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-[color:var(--brand-navy)] text-white" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img src="/logo-white.png" alt="Cayman Fingerprinting Services Ltd." className="h-14 w-auto" />
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
              Professional fingerprint capture and submission services in the Cayman Islands. We are a private company,
              not a government agency.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/80">Our Services</h4>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => scrollTo(s.anchor)}
                    className="text-sm text-white/60 hover:text-white transition-colors duration-200 text-left"
                  >
                    {s.title}
                  </button>
                </li>
              ))}
              <li>
                <button
                  onClick={() => scrollTo("#booking")}
                  className="text-sm text-[color:var(--brand-sky)] hover:underline text-left font-medium"
                >
                  Schedule an Appointment
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/80">Contact</h4>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-white/60">
                <MapPin className="h-4 w-4 text-[color:var(--brand-sky)] shrink-0 mt-0.5" />
                {COMPANY.address}
              </li>
              <li>
                <a href={COMPANY.phoneHref} className="flex items-center gap-2.5 text-sm text-white/60 hover:text-white transition-colors duration-200">
                  <Phone className="h-4 w-4 text-[color:var(--brand-sky)] shrink-0" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={COMPANY.emailHref} className="flex items-center gap-2.5 text-sm text-white/60 hover:text-white transition-colors duration-200">
                  <Mail className="h-4 w-4 text-[color:var(--brand-sky)] shrink-0" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-white/60">
                <Clock className="h-4 w-4 text-[color:var(--brand-sky)] shrink-0" /> {COMPANY.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} Cayman Fingerprinting Services Ltd. All rights reserved.
          </p>
          <Link to="/admin" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200" data-testid="footer-admin-login-link">
            Staff Login
          </Link>
        </div>
      </div>
    </footer>
  );
};
